import pallet from 'constants/colors';

export default {
  subheader: {
    paddingLeft: 0,
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    cursor: 'pointer',
  },
  header: {
    flex: 1,
    fontSize: 20,
    fontWeight: 500,
  },
  root: {
    padding: 16,
  },
  info: {
    paddingTop: 16,
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  infoItem: {
    flexDirection: 'column',
    flexWrap: 'wrap',
    display: 'flex',
    padding: 6,
    minWidth: 260,
    overflow: 'hidden',
  },
  infoMessage: {
    flex: 1,
    flexBasis: 24,
  },
  label: {
    flex: 1,
    flexBasis: 24,
    color: 'rgb(176, 176, 176)',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  action: {
    marginLeft: 16,
  },
  errorText: {
    color: pallet.errorColor,
  },
};



// WEBPACK FOOTER //
// ./src/styles/Appraisal.js